/* eslint-disable react-hooks/rules-of-hooks */
import React, { memo, useEffect, useState } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import SwiperCore, { Autoplay, Pagination } from 'swiper';
import 'swiper/swiper.scss';
import 'swiper/components/pagination/pagination.scss';
import styles from './index.module.css';
import demo from './../../asset/img/indiba_animal.jpeg';
import tel from './../../asset/img/tel.png';
import addMorePng from './../../asset/img/add-more.png';
import warningPNG from './../../asset/img/warning.png';
import { fileUrl, swiperDefault } from '../../const';
import { getURLparmas } from '../../utils';
import { fetchEquipInfo, login } from '../../api/api';
import {
  DoubleRightOutlined,
  DownOutlined,
  LoadingOutlined,
  UpOutlined,
} from '@ant-design/icons';
import { useHistory } from 'react-router-dom';

const mapStyle = {
  useBefore: true, // 使用前检查
  attention: false, //
  useBeforeAndAfter: false, // 使用前后
  warning: false,
  faultHandling: false,
};

const Attention = memo(function index() {
  const [styleMap, setStyleMap] = useState<any>(mapStyle);

  /** 更多注意事项 */
  const handleSwitch = (style: string) => {
    setStyleMap({ ...styleMap, [style]: !styleMap[style] });
  };

  return (
    <div className={styles.wrapper} id='equipmentPage'>
        <div className={styles.inner}>
        <div className={styles.title}>维护、清洁和保养</div>
      <div className={styles.itemTitle}>
        <div>使用前检查</div>
        <div>
          {styleMap['useBefore'] ? (
            <UpOutlined onClick={() => handleSwitch('useBefore')} />
          ) : (
            <DownOutlined onClick={() => handleSwitch('useBefore')} />
          )}
        </div>
      </div>
      {styleMap['useBefore'] && <div className={styles.itemContent}>
        <p>使用本设备前，请检查设备及配件是否完好。特别注意电极的涂层，确保其没有任何损坏。</p>
        <p>禁止使用有缺陷或损坏的设备及配件操作客户。</p>
      </div>}
      <div className={styles.itemTitle}>
        <div>注意事项</div>
        <div>
          {styleMap['attention'] ? (
            <UpOutlined onClick={() => handleSwitch('attention')} />
          ) : (
            <DownOutlined onClick={() => handleSwitch('attention')} />
          )}
        </div>
      </div>
      {styleMap['attention'] && <div className={styles.itemContent}>
       <p>不要敲击电极或用尖锐的物体划伤电极。如有损坏，应立即更换。</p> 
        <p>电容式(CAP)电极不可使用酒精消毒。</p>
        <p>电容电极涂有聚酰亚胺涂层。不让它温度高于90ºC。</p>
        <p>使用无纤维的布或毛巾清除电极和回路板表面的残留物。</p>
        <p>不要对电极轴施加压力或力；不当的操作可能会导致电极排列不当或电极表面出现裂纹。</p>
        <p>始终保持设备处于良好状态。定期清洁。请勿使用腐蚀性或氧化性物质，如漂白剂或氨。</p>
      </div>}
      <div className={styles.itemTitle}>
        <div>使用前后</div>
        <div>
          {styleMap['useBeforeAndAfter'] ? (
            <UpOutlined onClick={() => handleSwitch('useBeforeAndAfter')} />
          ) : (
            <DownOutlined onClick={() => handleSwitch('useBeforeAndAfter')} />
          )}
        </div>
      </div>
      {styleMap['useBeforeAndAfter'] && <div className={styles.itemContent}>
        <p>每次使用前后用无纤维的布或毛巾清洁配件。</p>
        <p>设备使用后用水或有中性消毒液的毛巾清洁每个配件。晾干后再使用。</p>
        <p>建议为每种配件使用不同的毛巾擦拭。</p>
      </div>}
      <div className={styles.itemTitle}>
        <div>警告</div>
        <div>
          {styleMap['warning'] ? (
            <UpOutlined onClick={() => handleSwitch('warning')} />
          ) : (
            <DownOutlined onClick={() => handleSwitch('warning')} />
          )}
        </div>
      </div>
      {styleMap['warning'] && <div className={styles.itemContent}>
        <p>未经制造商批准，切勿篡改、修改和维修本设备。</p>
        <p>检查设备连接电压是否正确。允许的电源电压范围显示在设备背面的标签上。若使用环境电压不稳，请配置稳压器使用。</p>
        <p>设备四周至少保持20厘米距离便于风扇进行空气循环。设备顶部及风扇应远离障碍物，确保通风孔不被毛巾或衣物覆盖。</p>
        <p>仅能使用INDIBA®</p>
        <p>PROIONIC®导电膏。使用其它导电膏会影响效果，并且本公司不承担任何保修责任。未经授权的导电膏会导致灼伤以及缩短设备和配件的使用寿命。</p>
        <p>本设备不适用于易燃环境。 本设备不得与任何其它设备同时在客户身上使用。</p>
        <p>如果设备正在工作，请在插入、移除或更换电极之前按暂停键。</p>
        <p>切勿使用表现出劣化迹象的电极（操作头），例如涂层中的小孔、裂纹、碎屑、变形或隆起。</p>
        <p>切勿在未正确安装回流电极的情况下使用设备。</p>
        <p>切勿在未正确安装回流电极的情况下使用设备。</p>
        <p>如果电缆出现损坏或变质迹象，切勿使用。 开始使用前清洁操作区域。</p>
        <p>去除皮肤上任何可能影响操作的产品或物质。</p>
      </div>}
      <div className={styles.itemTitle}>
        <div>故障处理</div>
        <div>
          {styleMap['faultHandling'] ? (
            <UpOutlined onClick={() => handleSwitch('faultHandling')} />
          ) : (
            <DownOutlined onClick={() => handleSwitch('faultHandling')} />
          )}
        </div>
      </div>
      {styleMap['faultHandling'] && <div className={styles.itemContent}>
        <p>当设备检测到异常情况时，它会停止操作并显示错误代码提示。</p> 
        <p>错误代码的出现是为了保护用户、接受操作的人和设备本身。</p>
        <p>当出现错误代码提示时，请先拍下代码，同时建议您尝试重启设备2-3次，重新插拔设备上的配件看是否连接完好，若仍然出现代码，请联系我们。（电话: 010-85951853）</p>
      </div>}
        </div>
      
    </div>
  );
});

export { Attention };
